function cashObj(user,stats){
    this.progress=copyObj(user.progress_arr);
    delete user.progress_arr;
    this.user=copyObj(user);
    this.stats=copyObj(stats);
};
cashObj.prototype={
    updateUser:function(user){
        var user_old=copyObj(this.user);
        this.progress=copyObj(user.progress_arr);
        delete user.progress_arr;
        this.user=copyObj(user);
        
    },
    addOneProgress:function(film_add,time_end){
        var i,progress_id=0;
        for(i in this.progress){
            progress_id=Math.min(progress_id,this.progress[i].progress_id);
        }
        progress_id--;
        this.progress[progress_id]={film_add:film_add,time_end:time_end,progress_id:progress_id};
    },
    takeTimeBonus:function(){
        var bonus=_userArr['speed_bonus_global'];
        return bonus;
    },
    takeClosestProgressTime:function(){
        var closest=0,i,bum,time=getCurrentTime();
        for(i in this.progress){
            bum=this.progress[i];
            if((closest===0 || bum.time_end < closest )&& bum.time_end>time){
                closest=bum.time_end;
            }
        }
        return closest;
    },
    isWorking:function(){
        if(this.user.time_start==0){
            return 0;
        }
        return 1;
    },
    isOwn:function(){
        if(this.user['level']>=2 || this.user['film_have']>0){
            return 1;
        }
        return 0;
    },
    
    takeCash:function(return_user){
        
        
        
        var i,bum,tmp=copyObj(this.progress),progress_arr=[];
        for(i in tmp){
            progress_arr.push(tmp[i]);
        }
        mySortArr(progress_arr,"time_end");
        
        
        var arr_time=[];
        var time=getCurrentTime();
        var time_from=this.user['time_start'];
        var user=copyObj(this.user);
        var was_new_level,cash_on_hour;
        for(i in progress_arr){
            bum=progress_arr[i];
            if(bum['time_end']<=time){
                was_new_level=0;
                user['film_have']+=bum['film_add'];
                user['film_have_all']+=bum['film_add'];
                cash_on_hour=user['cash_on_hour'];
                while(user['film_have']>=user['film_end'] && typeof this.stats[user['level']+1]!="undefined"){
                    user['film_have']-=user['film_end'];
                    user['level']++;
                    
                    user['cash_on_hour']=this.stats[user['level']]["cash_on_hour"];
                    if(typeof this.stats[user['level']+1]!="undefined"){
                        user['film_end']=this.stats[user['level']+1]["film"];
                    }
                    
                }
                if(was_new_level && time_from<bum['time_end']){
                    arr_time.push({"time_start":time_from,"time_end":bum['time_end'],"cash_on_hour":cash_on_hour});
                    time_from=bum['time_end'];
                }
            }
        }
        var cash=bigInt(0);
        var bonus=this.takeTimeBonus();
        if(this.user['time_start']>0){
            if(time_from<time){
                arr_time.push({"time_start":time_from,"time_end":time,"cash_on_hour":user['cash_on_hour']});
            }


            var howlong;

            for(i in arr_time){
                bum=arr_time[i];
                howlong=bum['time_end']-bum['time_start'];
                cash=cash.add(bigInt(bum['cash_on_hour']).multiply(howlong));
            }
        }
        
        //on hour
        cash=cash.divide(3600);
        //3600
        //add bonus
        if(bonus<1000 && cash.lt(intval(Math.pow(10,6)))){
            cash=Math.floor(cash*bonus);
        }
        else{
            cash=cash.multiply(Math.floor(bonus));
        }
       
        if(return_user){
            user["bonus_all"]=bonus;
            if(bonus<1000 && bigInt(user['cash_on_hour']).lt(intval(Math.pow(10,6)))){
                user["cash_on_hour_with_bonus"]=Math.floor(user['cash_on_hour']*bonus);
            }
            else{
                user["cash_on_hour_with_bonus"]=bigInt(user['cash_on_hour']).multiply(Math.floor(bonus));
            }
            return user;
        }
        return cash;
        
    },
    getLevel:function(){
        var user=this.takeCash(1);
        return user.level;
    },
    getLevelMax:function(){
        return this.user.level_max;  
    },
};


function cashObjSet(){
    this.stats={};
    this.objSet={};
    this.was_init=0;
};
cashObjSet.prototype={
    init:function(stats,user_arr){
        this.stats=copyObj(stats);
        var id;
        for(id in this.stats){
            this.objSet[id]=new cashObj(user_arr[id],this.stats[id]);
        }
        this.was_init=1;
    },
    updateSet:function(user_arr){
        var id;
        for(id in user_arr){
            this.objSet[id].updateUser(user_arr[id]);
        }
    },
    takeTimeToCash:function(cash){
        
    },
    takeStat:function(cash_id,level){
        return copyObj(this.stats[cash_id][level]);
    },
    takeCash:function(){
        if(!this.was_init){
            return 0;
        }
        var cash;
        cash=bigInt(_myProfile.data.cash);
        
        var i;
        for(i in this.objSet){
            cash=cash.add(this.objSet[i].takeCash());
        }
        return cash;
    }
    
};
var _cashObjSet= new cashObjSet();



//testHowlong(function(){var i;for(i=0;i<1000;i++){_cashObjSet.takeCash();}})